




































import { Vue, Component, State, namespace, Prop, Inject, Watch } from 'nuxt-property-decorator'
import ExperienceFilterModal from '~/components/experience/search-filter/desktop/filter-modal.vue'
import { Experience } from '~/types/experience'

import UrlQuery = Experience.UrlQuery

const experience = namespace('experience')

@Component({
  components: {
    ExperienceFilterModal
  }
})

export default class ExperienceFilterPrice extends Vue {
  @State klook!: Data.Klook
  @State(state => state.klook.platform) platform!: Data.Klook
  @experience.State priceFrom!: number
  @experience.State priceTo!: number
  @experience.Action setUrlQuery!: Function
  @experience.State urlQuery!: UrlQuery
  @experience.State filterConditions!: any
  // @experience.State isOverLimitCount!: boolean
  @Prop({ default: true }) showReset!: boolean
  @Prop({ default: false }) isAbExperiment!: boolean
  @Prop() max!: number
  @Prop() min!: number
  @Prop() visible!: boolean
  @Inject({ default: (_: any) => _ }) resetPage!: Function

  price: number[] = [0, 0]
  fromPrice: number = 0
  toPrice: number = 0

  hide() {
    this.$emit('hide')
  }

  @Watch('visible')
  onVisibleChange(val: boolean) {
    val && this.setPrice()
  }

  get disable() {
    if (this.isAbExperiment) {
      return this.max <= 0
    }

    return this.priceTo <= 0
  }

  get minRange() {
    if (this.isAbExperiment) {
      return this.min
    }

    return this.priceFrom
  }

  get maxRange() {
    if (this.isAbExperiment) {
      return this.max
    }

    return this.priceTo
  }

  change() {
    // 价格区间不算filter条件，真的难理解。代码先留着，以防万一
    // if (this.isAbExperiment && this.isOverLimitCount && !('price_range' in this.filterConditions)) {
    //   this.$toast(this.$t('83288', { num: 20 }))
    //   this.price = [this.min, this.max]
    //   this.fromPrice = this.price[0]
    //   this.toPrice = this.price[1]
    //   return
    // }

    if (this.price[0] !== this.priceFrom && this.price[1] === this.priceTo) {
      this.fromPrice = this.price[0]
      this.toPrice = this.isAbExperiment ? this.price[1] : 0
    } else if (this.price[0] !== this.priceFrom || this.price[1] !== this.priceTo) {
      this.fromPrice = this.price[0]
      this.toPrice = this.price[1]
    } else {
      this.fromPrice = this.isAbExperiment ? this.min : 0
      this.toPrice = this.isAbExperiment ? this.max : 0
    }

    if (this.isAbExperiment && this.fromPrice === this.min && this.toPrice === this.max) {
      this.$emit('change')
    } else {
      this.$emit('change', {
        fromPrice: this.fromPrice,
        toPrice: this.toPrice
      })
    }
  }

  submit() {
    this.resetPage && this.resetPage()
    this.setUrlQuery({
      price_from: this.fromPrice || '',
      price_to: this.toPrice || '',
      page: 1
    })
    const submitButton = (this.$refs.submitButton as Vue).$el
    if (submitButton) {
      this.$inhouse.updateBinding(submitButton, {
        ext: {
          PriceRange: `(${this.fromPrice}, ${this.toPrice})`
        }
      })
      this.$inhouse.track('action', submitButton)
    }
    const a = setTimeout(() => {
      this.hide()
      clearTimeout(a)
    })
  }

  reset() {
    this.fromPrice = 0
    this.toPrice = 0

    if (this.isAbExperiment) {
      this.price = [this.min, this.max]
    } else {
      this.price = [this.priceFrom, this.priceTo]
    }
  }

  setPrice() {
    const { priceFrom, priceTo, urlQuery = {}, isAbExperiment, max, min } = this || {}
    const { price_range = null } = this.filterConditions
    let price: any = [min, max]

    if (!isAbExperiment) {
      price = [priceFrom, priceTo]
      if (urlQuery.price_from) {
        price[0] = Number(urlQuery.price_from) || 0
      }
      if (urlQuery.price_to) {
        price[1] = Number(urlQuery.price_to) || 0
      }
    } else if (price_range) {
      const { fromPrice, toPrice } = price_range
      price = [fromPrice, toPrice]
    }

    this.price = price
    this.$forceUpdate()
  }

  mounted() {
    this.setPrice()
  }
}
